export const TipoMedioEnvioVerificacion = {
  EMAIL: 1,
  SMS: 2,
} as const;

export type TipoMedioEnvioVerificacion =
  (typeof TipoMedioEnvioVerificacion)[keyof typeof TipoMedioEnvioVerificacion]; // 1 | 2

export const TipoVerificacionEnum = {
  LOGIN_CON_EMAIL: 1,
  LOGIN_CON_TELEFONO: 2,
  CREAR_CUENTA: 3,
  CAMBIO_EMAIL: 4,
  CAMBIO_TELEFONO: 5,
  CAMBIO_CONTRASENA: 6,
  VINCULAR_TELEFONO: 7,
  CREAR_CONTRASENA: 8,
  AFILIAMIENTO_MANUAL: 9,
} as const;

export type TipoVerificacion =
  (typeof TipoVerificacionEnum)[keyof typeof TipoVerificacionEnum]; // 1 | 2
export type TipoVerificacionKey = keyof typeof TipoVerificacionEnum;

const mapTipoVerificacionToTipoMedioEnvioVerificacion: Record<
  TipoVerificacion,
  TipoMedioEnvioVerificacion
> = {
  [TipoVerificacionEnum.LOGIN_CON_EMAIL]: TipoMedioEnvioVerificacion.EMAIL,
  [TipoVerificacionEnum.LOGIN_CON_TELEFONO]: TipoMedioEnvioVerificacion.SMS,
  [TipoVerificacionEnum.CREAR_CUENTA]: TipoMedioEnvioVerificacion.SMS,
  [TipoVerificacionEnum.CAMBIO_EMAIL]: TipoMedioEnvioVerificacion.EMAIL,
  [TipoVerificacionEnum.CAMBIO_TELEFONO]: TipoMedioEnvioVerificacion.SMS,
  [TipoVerificacionEnum.VINCULAR_TELEFONO]: TipoMedioEnvioVerificacion.EMAIL,
  [TipoVerificacionEnum.CAMBIO_CONTRASENA]: TipoMedioEnvioVerificacion.SMS,
  [TipoVerificacionEnum.CREAR_CONTRASENA]: TipoMedioEnvioVerificacion.SMS,
  [TipoVerificacionEnum.AFILIAMIENTO_MANUAL]: TipoMedioEnvioVerificacion.SMS,
};

export const getMedioEnvioVerificacion = (
  tipoVerificacion: TipoVerificacion
) => {
  return (
    mapTipoVerificacionToTipoMedioEnvioVerificacion[tipoVerificacion] || null
  );
};
